import React from "react";
import classes from "./SiteMap.module.scss";
import { Container } from "react-bootstrap";
import CustomLink from "../../CustomLink";
import Accordion from "../../UI/Accordion/Accordion";

interface SiteMapNavLink {
  id: string | number;
  label: string;
  link: any;
}

interface SiteMapSection {
  id: string | number;
  title: string;
  navLinks: SiteMapNavLink[];
}

const SiteMap: React.FC<{ footerData: any }> = ({ footerData }) => {
  const siteMapData: SiteMapSection[] = footerData?.siteMapLinks ?? [];

  if (!siteMapData.length) return null;

  const accordionItems = siteMapData.map((item) => ({
    title: item.title,
    description: (
      <div className={classes.siteMapList}>
        {item.navLinks.map((el, index, arr) => (
          <React.Fragment key={el.id}>
            <CustomLink data={el.link}>{el.label}</CustomLink>
            {index !== arr.length - 1 && <div className={classes.siteMapSeparator}>|</div>}
          </React.Fragment>
        ))}
      </div>
    ),
  }));

  return (
    <>
      {siteMapData.length > 0 ? (
        <Container>
          <div className={classes.lineBottom} />
          <Accordion
            items={accordionItems}
            icon="chevron-circle"
            defaultOpenIndex={-1}
            accordionItemStyles={{ borderBottom: "none" }}
            titleStyles={{ color: "#868697" }}
          />
        </Container>
      ) : (
        <></>
      )}
    </>
  );
};

export default SiteMap;
